import { Skeleton as AntSkeleton } from 'antd';
import styled from 'styled-components';

export const Skeleton = styled(AntSkeleton)`
  padding: var(--spacing-05);
  background: var(--white-100);
`;
